import { z } from "zod";

/**
 * CopyObraSchema
 */

export const CopyObraSchema = z.object({
  idCentroCusto: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }),
  copiarChecklist: z.coerce.number({ required_error: 'Este campo deve ser preenchido!' }).default(0),
});

/**
 * CopyObraForm
 */

export type CopyObraForm = z.infer<typeof CopyObraSchema>;